/* global mapboxgl */

import { $, $$ } from '../utils/query-selector.js'
import loadjs from 'loadjs'
import bbox from '@turf/bbox'

const MAPBOX_JS_URL = 'https://api.mapbox.com/mapbox-gl-js/v2.3.0/mapbox-gl.js'
const MAPBOX_CSS_URL = 'https://api.mapbox.com/mapbox-gl-js/v2.3.0/mapbox-gl.css'

class MapComponent {
  constructor (el, id) {
    this.id = id
    this.el = el
    this.container = $('.js-map__mapbox', el)

    this.mapboxAccessToken = el.getAttribute('data-mapbox-access-token')
    this.styleUrl = el.getAttribute('data-mapbox-style-url')
    this.maxZoom = 5
    this.mapId = `map__${this.id}`

    this.container.setAttribute('id', this.mapId)

    // Get Results
    this.data = JSON.parse(el.getAttribute('data-locations'))

    console.log('dataaa', this.data, bbox(this.data))
    this.container.style.setProperty('visibility', false)

    this.init()
  }

  init () {
    this.map = new mapboxgl.Map({
      container: this.mapId,
      style: this.styleUrl,
      accessToken: this.mapboxAccessToken,
      fitBoundsOptions: {
        padding: this.getCurrentPaddingBox(),
        maxZoom: this.maxZoom
      },
      logoPosition: 'bottom-right',
      scrollZoom: false,
      dragRotate: false,
      touchZoomRotate: true,
      attributionControl: false,
      boxZoom: true,
      dragPan: true,
      keyboard: true,
      doubleClickZoom: true
    })

    // Disable touch rotation, but keep multi-touch zoom enabled
    this.map.touchZoomRotate.disableRotation()

    this.map.on('load', () => {
      this.map.addControl(new mapboxgl.NavigationControl({
        showCompass: false
      }), 'top-left')

      this.addMarkers()

      this.map.fitBounds(this.getBounds(), {
        animate: false,
        padding: this.getCurrentPaddingBox(),
        maxZoom: this.maxZoom
      })
      this.container.style.removeProperty('visibility')
    })
  }

  getBounds () {
    return bbox(this.data)
  }

  getCurrentPaddingBox () {
    return {
      top: Math.round(window.innerHeight * 5 / 100) + 50,
      right: 50,
      bottom: Math.round(window.innerHeight * 5 / 100) + 50,
      left: 50
    }
  }

  addMarkers () {
    this.map.addLayer({
      id: 'locations',
      type: 'symbol',
      source: {
        type: 'geojson',
        data: this.data
      },
      layout: {
        'icon-allow-overlap': true
      }
    })

    this.data.features.forEach((item, i) => {
      const el = document.createElement('div')
      el.className = 'c-map__result-marker'
      el.locationEntry = item

      const link = document.createElement('a')

      link.href = item.properties.url
      link.setAttribute('title', item.properties.title)
      link.className = 'c-map__result-link'
      el.appendChild(link)

      const marker = new mapboxgl.Marker(el, {})
        .setLngLat(item.geometry.coordinates)
        .addTo(this.map)

      // Store properties in
      item.properties.marker = marker
      item.properties.originalIndex = i
      item.properties.distance = null
    })
  }
}

(() => {
  const maps = $$('.js-map')

  if (maps.length === 0) {
    return
  }

  // Load Mapbox JS and CSS from CDN conditionally
  loadjs([
    MAPBOX_CSS_URL,
    MAPBOX_JS_URL
  ], () => {
    for (let i = 0, l = maps.length; i < l; i++) {
      /* eslint-disable-next-line no-new */
      new MapComponent(maps[i], i)
    }
  })
})()
